import { DataTableV2Column } from '@app/storybook/components/data-table-v2/data-table-v2.model';
import { AddressCorrectionAddress, AddressCorrectionHistoryItem } from './address-validation-flagged-orders.types';

function formatName(address: AddressCorrectionAddress | null): string {
  if (!address) return '';
  return `${address.firstName} ${address.lastName}`.trim();
}

function formatAddress(address: AddressCorrectionAddress | null): string {
  if (!address) return '';
  return [address.address1, address.city, address.provinceCode, address.zip].filter(Boolean).join(', ');
}

export const FLAGGED_ORDERS_COLUMNS: DataTableV2Column<AddressCorrectionHistoryItem>[] = [
  { prop: 'orderName', label: 'Order' },
  {
    prop: 'customer',
    label: 'Customer',
    valueFn: (row) => formatName(row.originalAddress),
  },
  {
    prop: 'originalAddress',
    label: 'Address',
    valueFn: (row) => formatAddress(row.originalAddress),
  },
  {
    prop: 'status',
    label: 'Status',
  },
  {
    prop: 'correctedAddress',
    label: 'Corrected Address',
    valueFn: (row) => formatAddress(row.correctedAddress),
  },
];
